import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Checkbox,
  Chip,
  FormControl,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@material-ui/core/'

class CommunityUnitSelectContainer extends React.Component {
  static propTypes = {
    /* passed props */
    communityId: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    unitIds: PropTypes.array.isRequired,
    /* mapped state */
    units: PropTypes.object.isRequired,
    unitsByCommunity: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      units: state.units,
      unitsByCommunity: state.unitsByCommunity,
    }
  }

  getUnits = () => {
    const { communityId, units, unitsByCommunity } = this.props
    const unitIds = unitsByCommunity[communityId]
    const communityUnits = unitIds ? unitIds.map((id) => units[id] || { id, name: id }) : []
    return [...communityUnits].sort((a, b) => a.name.localeCompare(b.name))
  }

  render() {
    const units = this.getUnits()

    return (
      <FormControl fullWidth>
        <InputLabel htmlFor="unit-select">Unit Selection</InputLabel>
        <Select
          multiple
          value={this.props.unitIds}
          onChange={this.props.onChange}
          input={<Input id="unit-select" />}
          renderValue={(selected) => (
            <div>
              {selected.map((value) => (
                <Chip key={value} label={units.find((unit) => unit.id === value).name} />
              ))}
            </div>
          )}
        >
          {units.map((unit) => (
            <MenuItem key={unit.id} value={unit.id}>
              <Checkbox color="primary" checked={this.props.unitIds.indexOf(unit.id) > -1} />
              <ListItemText primary={unit.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }
}

export default connect(CommunityUnitSelectContainer.mapStateToProps)(CommunityUnitSelectContainer)
